import { nextMonday as nextMondayFns } from 'date-fns';

export default function nextMonday(date: Date): Date {
  return nextMondayFns(date);
}
